import { PromotionRadioInputField } from './PromotionRadioInputField'
import { withPromotionRadioInputField } from './withPromotionRadioInputField'

const ConnectedPromotionRadioInputField = withPromotionRadioInputField(
  PromotionRadioInputField
)

export { ConnectedPromotionRadioInputField as PromotionRadioInputField }
